<template>
    <div class="index">
        <navLeft></navLeft>
        <headNav></headNav>
         <router-view></router-view>
        <!-- <foot></foot> -->
    </div>

</template>

<script>
    import navLeft from '../components/navLeft.vue';
    import headNav from '../components/headNav.vue'; 
    // import foot from "../components/foot.vue";
    export default{
        name: 'index',
        components: { 
            navLeft,
            headNav,
            // foot
        }
    }
</script>

<style scoped>
    .index{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/index.vue